<template>
    <div id="welcome">
        <Header :media="message.media" />
        <section>
            <h1>{{ message.headline }}</h1>
            <p v-for="(text, index) in message.paragraphs" v-html="text" v-bind:key="index">
            </p>
            <Button v-for="(button, index) in message.buttons" :colors="button_colors" v-bind:key="index" :action="index" :text="button" @start="update" />
        </section>
    </div>
</template>

<script>
import Button from './Button.vue'
import Header from './Header.vue'

export default {
    name: 'Welcome',
    props: ['message','button_colors'],
    components: {
        Button,
        Header
    },
    data: function(){
        return{
           
        }
    },
    methods:{
        update(){
            this.$emit('start')
        },
    }
}
</script>
